// extracted by mini-css-extract-plugin
export var bubble = "_4c-0";
export var container = "_4c-f";
export var contrastBorder = "_4c-g";
export var greyOut = "_4c-2";
export var initialsColor0 = "_4c-3";
export var initialsColor1 = "_4c-4";
export var initialsColor10 = "_4c-d";
export var initialsColor11 = "_4c-e";
export var initialsColor2 = "_4c-5";
export var initialsColor3 = "_4c-6";
export var initialsColor4 = "_4c-7";
export var initialsColor5 = "_4c-8";
export var initialsColor6 = "_4c-9";
export var initialsColor7 = "_4c-a";
export var initialsColor8 = "_4c-b";
export var initialsColor9 = "_4c-c";
export var initialsWrapper = "_4c-1";
export var large = "_4c-l";
export var medium = "_4c-k";
export var mediumSmall = "_4c-j";
export var mediumSmallMedium = "_4c-o";
export var micro = "_4c-h";
export var small = "_4c-i";
export var tiny = "_4c-n";
export var xTiny = "_4c-m";